import { createSlice } from '@reduxjs/toolkit';
import { Log, LogPagination, LogSummary } from '../Model/Log';
import { 
  fetchLogs, 
  fetchLogsPage,
  fetchLogsSummary,
  fetchTodayLogs, 
  fetchYesterdayLogs, 
  fetchThisMonthLogs, 
  fetchCustomRangeLogs,
  deleteLog,
  updateLogWithoutRecord,
  downloadLogsExcel
} from './actions';

interface State {
  list: Log[];
  loading: boolean;
  error?: string;
  pagination: LogPagination | null;
  summary: LogSummary | null;
}

const initialState: State = { list: [], loading: false, pagination: null, summary: null };

const slice = createSlice({
  name: 'log',
  initialState,
  reducers: {},
  extraReducers: b => {
    // 기본 로그 조회
    b.addCase(fetchLogs.pending, s => { s.loading = true; })
     .addCase(fetchLogs.fulfilled, (s, a) => { s.list = a.payload; s.pagination = null; s.loading = false; })
     .addCase(fetchLogs.rejected, (s, a) => { s.loading = false; s.error = a.error.message; })

     // 서버 페이지네이션 로그 조회
     .addCase(fetchLogsPage.pending, s => {
        s.loading = true;
        s.list = [];
        s.pagination = null;
     })
     .addCase(fetchLogsPage.fulfilled, (s, a) => {
        s.list = a.payload.results;
        s.pagination = a.payload;
        s.loading = false;
     })
     .addCase(fetchLogsPage.rejected, (s, a) => { s.loading = false; s.error = a.error.message; })

     // 요약 합계 조회
     .addCase(fetchLogsSummary.pending, s => {
        s.summary = null;
     })
     .addCase(fetchLogsSummary.fulfilled, (s, a) => {
        s.summary = a.payload;
     })
     .addCase(fetchLogsSummary.rejected, (s, a) => { s.error = a.error.message; })
     
     // 오늘 로그
     .addCase(fetchTodayLogs.pending, s => { s.loading = true; })
     .addCase(fetchTodayLogs.fulfilled, (s, a) => { s.list = a.payload; s.pagination = null; s.loading = false; })
     .addCase(fetchTodayLogs.rejected, (s, a) => { s.loading = false; s.error = a.error.message; })
     
     // 어제 로그
     .addCase(fetchYesterdayLogs.pending, s => { s.loading = true; })
     .addCase(fetchYesterdayLogs.fulfilled, (s, a) => { s.list = a.payload; s.pagination = null; s.loading = false; })
     .addCase(fetchYesterdayLogs.rejected, (s, a) => { s.loading = false; s.error = a.error.message; })
     
     // 이번달 로그
     .addCase(fetchThisMonthLogs.pending, s => { s.loading = true; })
     .addCase(fetchThisMonthLogs.fulfilled, (s, a) => { s.list = a.payload; s.pagination = null; s.loading = false; })
     .addCase(fetchThisMonthLogs.rejected, (s, a) => { s.loading = false; s.error = a.error.message; })
     
     // 기간별 로그
     .addCase(fetchCustomRangeLogs.pending, s => { s.loading = true; })
     .addCase(fetchCustomRangeLogs.fulfilled, (s, a) => { s.list = a.payload; s.pagination = null; s.loading = false; })
     .addCase(fetchCustomRangeLogs.rejected, (s, a) => { s.loading = false; s.error = a.error.message; })
     
     // 로그 삭제
     .addCase(deleteLog.pending, s => { s.loading = true; })
     .addCase(deleteLog.fulfilled, (s, a) => { s.loading = false; })
     .addCase(deleteLog.rejected, (s, a) => { s.loading = false; s.error = a.error.message; })

     // 로그 수정 (리스트에서도 즉시 반영)
     .addCase(updateLogWithoutRecord.pending, s => { s.loading = true; })
     .addCase(updateLogWithoutRecord.fulfilled, (s, a) => {
        const updated = a.payload;
        const idx = s.list.findIndex(l => l.logId === updated.logId);
        if (idx !== -1) s.list[idx] = { ...s.list[idx], ...updated };
        s.loading = false;
     })
     .addCase(updateLogWithoutRecord.rejected, (s, a) => { s.loading = false; s.error = a.error.message; })

     // 서버 엑셀 다운로드 완료 시점에는 리스트 변경 없음
     .addCase(downloadLogsExcel.pending, s => { s.loading = true; })
     .addCase(downloadLogsExcel.fulfilled, (s) => { s.loading = false; })
     .addCase(downloadLogsExcel.rejected, (s, a) => { s.loading = false; s.error = a.error.message; });
  },
});
export default slice.reducer;
